import { render, staticRenderFns } from "./BankProductProfile.vue?vue&type=template&id=461b3867"
import script from "./BankProductProfile.vue?vue&type=script&lang=js"
export * from "./BankProductProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports